import type { IconProps } from './types';

export const YouTube = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" aria-hidden="true" {...props}>
    <g clipPath="url(#clip0_15916_7178)">
      <path
        d="M19.1676 8.5916c.0412-1.19271-.2196-2.3765-.7583-3.44144-.3654-.43697-.8727-.73186-1.4332-.83328-2.3186-.21038-4.6468-.29661-6.9746-.25832-2.31927-.04003-4.63907.04342-6.94951.24999-.45678.08309-.87951.29735-1.21658.61662-.74996.69163-.83328 1.87488-.916611 2.87482-.120899 1.79785-.120899 3.60181 0 5.39961.024107.5628.107901 1.1215.249981 1.6666.10048.4209.30375.8102.59163 1.1333.33937.3361.77194.5626 1.24159.6499 1.79648.2218 3.60661.3137 5.41631.275 2.91649.0417 5.47469 0 8.49949-.2333.4811-.082.9259-.3087 1.2749-.65.2333-.2334.4075-.519.5083-.8333.298-.9144.4443-1.8714.4333-2.8331.0333-.4666.0333-3.28313.0333-3.7831ZM8.11833 12.8747V7.71666l4.93297 2.59154c-1.3832.7666-3.20808 1.6332-4.93297 2.5665Z"
        fill="var(--color-quanta-icon)"
        fillOpacity="0.3"
      />
    </g>
    <defs>
      <clipPath id="clip0_15916_7178">
        <rect width="19.9987" height="19.9987" fill="var(--color-quanta-icon)" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
